<template>
  <el-switch @change="change" v-model="hasLcrModule"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      hasLcrModule: false
    }
  },
  props : {

      accManagerId: {
      required: true
    },
      data: {
      required: true
    },
      actionsHandler: {
      required: true
    },
  },
  beforeMount() {
    //   let dat = this.params;
    // let accManager = this.accManagerId;
    // let data = this.data.carier_relation_manager_user_id;
    // debugger
    // this.hasLcrModule = (this.params.data.has_lcr === 1)
    // let post = this.params.data.account_manager_user_id
    // let pree = this.params.props.passed.id
    let post = this.accManagerId.id
    let pree = this.data.carier_relation_manager_user_id;
    this.hasLcrModule = post == pree ? true : false ;
    // this.hasLcrModule = is;
    //   debugger
    // this.hasLcrModule = this.params.data.account_manager_user_id == this.params.props.passed.id

  },
  
  methods: {
    change(val) {
         
          let account_manager_id = this.accManagerId.id;
          let user_id = this.data.id;
        //   debugger
      // console.log(par);
      
      let data = {
        value: val,
        userId: user_id,
        accountManagerId : account_manager_id
      }
    //   debugger
      this.actionsHandler('assignVendorsToCarierRelationManager', data)
    }
  }
}
</script>
